import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=382adc26&scoped=true&"
import script from "./Play.vue?vue&type=script&lang=js&"
export * from "./Play.vue?vue&type=script&lang=js&"
import style0 from "./Play.vue?vue&type=style&index=0&id=382adc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382adc26",
  null
  
)

export default component.exports